export interface FiscalMonth {
  label: string;
  startDate: string;
  endDate: string;
  weekNumber: number;
  year: number;
  quarter: number;
  month: number;
}

export interface CalendarMonth {
  label: string;
  days: string[];
  weeks: string[][];
  weekNumbers: number[];
  year: number;
  quarter: number;
  startDate: string;
  endDate: string;
  dateRangeLabel: string;
}

export interface DateRangeSelection {
  startDate: Date;
  endDate: Date;
  previousStartDate: Date | null;
  previousEndDate: Date | null;
}

export type ViewerType = 'current' | 'previous';

export interface CalendarViewer {
  viewerType: ViewerType;
  startIndex: number;
  windowSize: number;
}

export const WEEK_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export type DateRange = { start: string | null; end: string | null };
